/**
 * Jezik vmesnika in porocil.
 *
 * Aplikacija je dvojezicna (docs/ARHITEKTURA.md, 7): vsa polja z nazivi imajo
 * slovenski in angleski naziv, ce angleskega ni, se prikaze slovenski. Seznam
 * je tu, ker ga potrebujeta oba dela aplikacije - vmesnik za preklop, streznik
 * za preverjanje in izbiro naziva.
 */
export const JEZIKI = ['sl', 'en'];
/** Privzeti jezik; uporabi se, kadar izbire ni ali ni veljavna. */
export const PRIVZETI_JEZIK = 'sl';
/** Ali je niz eden od podprtih jezikov. */
export function jeJezik(vrednost) {
    return typeof vrednost === 'string' && JEZIKI.includes(vrednost);
}
/** Veljaven jezik iz poljubne vrednosti; neveljavna da privzetega. */
export function vJezik(vrednost, privzeti = PRIVZETI_JEZIK) {
    return jeJezik(vrednost) ? vrednost : privzeti;
}
/**
 * Naziv v izbranem jeziku.
 *
 * Angleski naziv je neobvezen (nastavitev, ki je admin morda se ni izpolnil),
 * zato se v angleskem pogledu prikaze slovenski, namesto da bi vrstica ostala
 * prazna.
 */
export function naziv(jezik, nazivSl, nazivEn) {
    return jezik === 'en' && nazivEn !== null && nazivEn !== undefined && nazivEn !== ''
        ? nazivEn
        : nazivSl;
}
//# sourceMappingURL=jezik.js.map